export class LayoutState {
  public sideNavOpened: boolean;
  public title: string;
}
